'use client';

import * as React from 'react';
import * as RadioGroupPrimitive from '@radix-ui/react-radio-group';
import { CircleIcon } from 'lucide-react';

import { cn } from '../lib';

/**
 * Root container for a radio group, based on Radix UI's RadioGroup primitive.
 */
function RadioGroup({
  className,
  ...props
}: React.ComponentProps<typeof RadioGroupPrimitive.Root>) {
  return (
    <RadioGroupPrimitive.Root
      className={cn('grid gap-3', className)}
      data-slot="radio-group"
      {...props}
    />
  );
}

/**
 * An individual radio item within a radio group.
 */
function RadioGroupItem({
  className,
  ...props
}: React.ComponentProps<typeof RadioGroupPrimitive.Item>) {
  return (
    <RadioGroupPrimitive.Item
      className={cn(
        `border-input text-primary focus-visible:border-ring focus-visible:ring-ring/50
        aria-invalid:ring-destructive/20 dark:aria-invalid:ring-destructive/40
        aria-invalid:border-destructive dark:bg-input/30 size-4 shadow-xs aspect-square
        shrink-0 rounded-full border outline-none transition-[color,box-shadow]
        focus-visible:ring-[3px] disabled:cursor-not-allowed disabled:opacity-50`,
        className
      )}
      data-slot="radio-group-item"
      {...props}
    >
      <RadioGroupPrimitive.Indicator
        className="relative flex items-center justify-center"
        data-slot="radio-group-indicator"
      >
        <CircleIcon
          className="
            fill-primary size-2 absolute left-1/2 top-1/2 -translate-x-1/2
            -translate-y-1/2
          "
        />
      </RadioGroupPrimitive.Indicator>
    </RadioGroupPrimitive.Item>
  );
}

export { RadioGroup, RadioGroupItem };
